module.exports = __webpack_public_path__ + "img/icon_proveedores_over.fcb08cad.svg";